/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface LoginRefresh200Response
 */
export interface LoginRefresh200Response {
    /**
     * A short-lived token that can be used to authenticate requests
     * @type {string}
     * @memberof LoginRefresh200Response
     */
    token?: string;
    /**
     * A longer-lived token that can be used to refresh the bearer token
     * @type {string}
     * @memberof LoginRefresh200Response
     */
    refreshToken?: string;
}


/**
 * Check if a given object implements the LoginRefresh200Response interface.
 */
export function instanceOfLoginRefresh200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function LoginRefresh200ResponseFromJSON(json: any): LoginRefresh200Response {
    return LoginRefresh200ResponseFromJSONTyped(json, false);
}

export function LoginRefresh200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRefresh200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'token': !exists(json, 'token') ? undefined : json['token'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
    };
}

export function LoginRefresh200ResponseToJSON(value?: LoginRefresh200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'token': value.token,
        'refreshToken': value.refreshToken,
    };
}

